module.exports = __webpack_public_path__ + "img/icon-family-values.f3639510.svg";